// Reconciled against contract v1 section 1.1 - the synchronous CommandResponse envelope
// returned after a command (reuses the device-management response shape).
export interface CommandResponse {
  command_id: string
  command: string
  status: 'success' | 'error'
  executed_at: string
  site_guid: string
  version: string
  result: CommandSuccessResult | CommandErrorResult
}

export interface CommandSuccessResult { channel_id?: string; [k: string]: unknown }
export interface CommandErrorResult { error_code: string; error_message: string }

export const isCommandError = (r: CommandResponse): r is CommandResponse & { result: CommandErrorResult } =>
  r.status === 'error'
